export const getGBBDetails = ({ gBBDetails: { currentGBBDetails }}) => currentGBBDetails
export const getGBBAvailability = ({ gBBDetails: { gBBAvailable }}) => gBBAvailable
export const getGBBTireSize = ({ gBBDetails: { gBBTireSize }}) => gBBTireSize
export const getGBBStoreNumber = ({ gBBDetails: { gBBStoreNumber }}) => gBBStoreNumber
